export default __webpack_public_path__ + "static/media/5.dd62c301.jpg";